<div
  class="meta-row-user-ring"
  [class.meta-row-user-ring--image]="!!avatarUrl()"
  aria-hidden="true"
>
  @if (avatarUrl()) {
    <img class="meta-row-user-avatar" [src]="avatarUrl()!" alt="" />
  } @else {
    <span class="meta-row-user-initials">
      {{ (initialsSource() | initials) || fallbackLetter() }}
    </span>
  }
</div>
<div class="meta-text">{{ displayName() }}</div>
